import dayjs from "dayjs";

export const getFilenameFromContentDisposition = (header?: string) => {
  if (!header) return "";

  const utf8Match = header.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) return decodeURIComponent(utf8Match[1]);

  const filenameMatch = header.match(/filename="?([^"]+)"?/i);
  return filenameMatch?.[1] ?? "";
};

export const getPivotExportFilename = (view: string) =>
  `pivot-${view}-${dayjs().format("YYYY-MM-DD")}.csv`;

export const downloadBlob = (filename: string, blob: Blob) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
